import { FetchError } from '../utilities/error';

export enum ErrorServiceEventNames {
  CATCH_ERROR = 'catchError'
}

const env = (typeof process !== 'undefined' && process?.env?.NODE_ENV) || 'development';

const isLocalhost =
  env === 'development' ||
  (typeof window !== 'undefined' &&
    (Boolean(
      window?.location?.hostname === 'localhost' ||
        // [::1] is the IPv6 localhost address.
        window?.location?.hostname === '[::1]' ||
        // 127.0.0.1/8 is considered localhost for IPv4.
        window?.location?.hostname?.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/)
    ) ||
      window?.localStorage.getItem('devtools') === 'true' ||
      (window as any)?.Cypress));

export class ErrorService extends EventTarget {
  errors: FetchError[] = [];
  isDev = false;

  constructor() {
    super();

    // @ts-ignore
    this.isDev = isLocalhost;
  }

  catch(error: FetchError | Error | unknown) {
    this.errors.push(ErrorService.transformError(error));

    if (this.isDev) console.error(error);

    this.dispatchEvent(new Event(ErrorServiceEventNames.CATCH_ERROR));
  }

  static transformError(error: FetchError | Error | unknown): FetchError {
    if (error instanceof FetchError) {
      return error;
    } else {
      const isString = typeof error === 'string';

      if (error instanceof Error) return new FetchError({ message: error.message, status: 500 });
      if (isString) return new FetchError({ message: error, status: 500 });

      // type unknown
      return new FetchError({ message: 'An unknown error occured.', status: 500 });
    }
  }

  reset() {
    this.errors = [];
  }
}
